<header>
  <img src="/img/budibase_logo.webp" alt="budi base logo" />
  <h1>Favorite Food List</h1>
</header>

<style>
  header {
    padding: 5px;
    text-align: center;
  }

  h1 {
    font-size: 25px;
    color: #111827;
  }

  img {
    max-width: 180px;
  }
</style>
